var React = require('react');
var PropTypes = React.PropTypes;
var moment = require('moment');
var $ = require('jquery');
import { Link, browserHistory } from 'react-router';
import AttemptRes from '../../resources/attempt';
import ConceptRes from '../../resources/concept';
import Auth from '../../resources/auth';
import Helpers from '../../utils/helpers';
import Solution from '../QuestionContent/Solution';
import MarkingProgress from './MarkingProgress';
import PartDescription from '../QuestionContent/LongQuestionFraction/PartDescription';
import PartAnswer from '../QuestionContent/LongQuestionFraction/PartAnswer';
import PartResult from '../QuestionContent/LongQuestionFraction/PartResult';
import RaisedButton from 'material-ui/RaisedButton';
import CircularProgress from 'material-ui/CircularProgress';
import '../../css/components/Marking/marking.css';
import createNotificationDialog from '../Modal/createNotificationDialog';
import ReactDOM from 'react-dom';

var ViewSubmission = React.createClass({
  retrieveAttempt: function(callback) {
    var _this = this;
    this.setState({isLoading: true}, function() {
      AttemptRes.retrieveSingleAttempt({attemptId: this.props.params.attemptId}, function(err, res) {
        _this.setState({
          attempt: (!err && res) ? res : {}
        }, function() {
          return callback(err, res);
        })
      })
    })
  },
  retrieveConceptsMap: function(callback) {
    callback = callback || function(){};
    var _this = this;
    ConceptRes.retrieveAllConceptsMap(function(err, conceptsMap) {
      _this.setState({
        conceptsMap: (!err && conceptsMap) ? conceptsMap : {},
        isLoading: false
      }, function() {
        return callback(err, conceptsMap);
      })
    })
  },
  navigateAnswer: function(dir) {
    this.setState({
      currentAnswerIndex: this.state.currentAnswerIndex + dir
    }, function() {
      $("body, html").animate({scrollTop: 0}, 200);
    })
  },
  chooseToMark: function() {
    this.retrieveAttempt(()=> {
      var attempt = this.state.attempt;
      var currentUser = Auth.getCurrentUser();
      if (attempt.status === 'marking' && attempt.metadata && attempt.metadata.marker && attempt.metadata.marker !== currentUser._id) {
        this.notificationDialog = createNotificationDialog({
          title: 'Error',
          content: 'This Submission has been marked by another teacher.'
        }, function() {
          if (attempt.type === 'PRACTICE') {
            browserHistory.push('/submissions/practice');
          } else {
            browserHistory.push('/submissions/exam');
          }
        })
        this.setState({openNotificationDialog: true});
      } else {
        browserHistory.push('marking/' + attempt._id);
      }
    });
  },

  getInitialState: function() {
    return {
      isLoading: false,
      attempt: null,
      conceptsMap: null,
      currentAnswerIndex: 0
    };
  },

  render: function() {
    var _this = this,
        attempt = this.state.attempt,
        conceptsMap = this.state.conceptsMap,
        answerIndex = this.state.currentAnswerIndex,
        currentUser = Auth.getCurrentUser(),
        isTeacher = currentUser.status.indexOf('teacher')>=0;

    var answers = [];
    if (attempt && attempt.answers && attempt.answers.length > 0) {
      for (var i = 0; i < attempt.answers.length; i++) {
        var item = {
            kquestionInfo: attempt.answers[i].kquestionInfo,
            textInputs: attempt.answers[i].textInputs,
            messages: attempt.answers[i].messages
        }
        // in case this attempt is a PRACTICE attempt, add all answers 
        // in case this attempt is a MOCK_EXAM attempt, only add answers of PART_2 which are long structure 
        if (attempt.type !== 'MOCK_EXAM' || (attempt.type === 'MOCK_EXAM' && attempt.answers[i].type && attempt.answers[i].type === 'PART_2')) {
          answers.push(item);
        } 
      }
    }
    var answer = answers.length > 0 ? answers[answerIndex] : {};
    return (
      <div>
        {this.state.openNotificationDialog && this.notificationDialog}
        {
          _this.state.isLoading &&
          <div className="central-innerpage-loader">
            <CircularProgress size={64}/>
          </div>
        }
        {
          !_this.state.isLoading && answers.length <= 0 &&
          <h3> No answers for marking </h3>
        }
        {
          !_this.state.isLoading && answers.length > 0 &&
          <div>
            <div className="content-toolbar">
              <h3>View Submissions</h3>
              <div className="btn-holder">
                <Link to="submissions/practice">
                  <RaisedButton
                    label="Back to Submission list"
                    icon={<i className="fa fa-angle-left"></i>}/>
                </Link>
                {
                  isTeacher && attempt && attempt.status === 'to_be_marked' &&
                  <RaisedButton
                    label="Mark this"
                    icon={<i className="fa fa-play" style={{color: "white"}}></i>}
                    labelPosition="before"
                    primary={true}
                    onClick={_this.chooseToMark}
                  />
                }
                {
                  isTeacher && attempt && attempt.status === 'marking' &&
                  <Link to={"marking/" + attempt._id}>
                    <RaisedButton
                      label="Continue"
                      secondary={true}
                    />
                  </Link>
                }
              </div>
              <hr/>
            </div>
            {
              attempt &&
              <div className="txt-primary margin-bottom-10" style={{fontSize: "17px"}}>
                <span className="padding-right-25">
                  Student:
                  <span className="txt-secondary padding-left-10">{attempt.creatorName}</span>
                </span>
                {
                  conceptsMap ?
                  <span className="padding-right-25">
                    Subject:
                    <span className="txt-secondary padding-left-10">{Helpers.getSubject(this.state.conceptsMap, attempt.concepts[0]).title}</span>
                  </span>
                  :
                  <span className="padding-right-25">No Subject</span>
                }
                {
                  attempt.type !== 'MOCK_EXAM' && conceptsMap &&
                    <span className="padding-right-25">
                      Concept:
                      <span className="txt-secondary padding-left-10">{this.state.conceptsMap[attempt.concepts[0]].title}</span>
                    </span>
                }
                {
                  attempt.type !== 'MOCK_EXAM' && !conceptsMap &&
                  <span className="padding-right-25">No Concept</span>
                } 
                {
                  attempt.type === 'MOCK_EXAM' && 
                  <span className="padding-right-25">{attempt.title}</span>
                }
                {
                  attempt.type === 'MOCK_EXAM' && 
                  <span className="padding-right-25">Exam paper 2</span>
                }
              </div>
            }
            {
              attempt && answers &&
              <div className="margin-top-10 margin-bottom-10">
                <MarkingProgress
                  answers={answers}
                  currentIndex={answerIndex}/>
              </div>
            }
            {
              attempt && conceptsMap &&
              <div className="content-play">
                <div className="text-desc">
                  <span className="question-index">{answerIndex+1}</span>
                  <span>
                    {(conceptsMap[answer.kquestionInfo.concepts[0]].title || 'No Concept') + " - "}
                  </span>
                  <span>{answer.kquestionInfo.score + " points"}</span>
                </div>
                <div className="content-title">
                  {
                    answer.kquestionInfo.image && <img src={answer.kquestionInfo.image} style={{"maxWidth": "100%"}}/>
                  }
                  <span dangerouslySetInnerHTML={{__html: answer.kquestionInfo.description || 'No Description'}}></span>
                </div>
                <div className="text-input-wrapper">
                  <div className="parts-list">
                    {
                      answer.kquestionInfo.textInputAnswers.map(function(textInput, index) {
                        return (
                          <div key={index} className="part" style={!(textInput.text && textInput.type === 'AUTO_MARKING') ? {"backgroundColor": "#ffefd5"} : {}}>
                            <PartDescription
                              content={textInput}
                              contentIndex={index}/>
                            <PartAnswer
                              content={answer.textInputs[index]}/>
                            <PartResult
                              answer={answer.textInputs[index]} 
                              info={textInput}/>
                            {
                              answer.kquestionInfo.solution[index] && answer.kquestionInfo.solution[index].subItems &&
                              <Solution solution={answer.kquestionInfo.solution[index].subItems} />
                            }
                            <div className="answer-marking">
                              <h3>Marking</h3>
                              <div
                                className={"form-group mark-form " + (textInput.markError === false ? "is-valid" : (textInput.markError === true ? "is-invalid" : ""))}
                                id={"mark-form-" + answerIndex + "-" + index}>
                                <label className="control-label margin-right-20">Mark</label>
                                <span className={"mark-value" + (answer.textInputs[index].answerValue ? "" : " default")}>
                                  {answer.textInputs[index].answerValue || ''}
                                </span>
                                <span className="total-mark">{"/  " + (textInput.answerValue)}</span>
                              </div>
                              <div className="comment-container">
                                {
                                  answer.messages.map(function(message, messageIndex) {
                                    if (!message.metadata || (message.metadata && message.metadata.textInputId !== textInput._id)) return null;
                                    return (
                                      <div className="comment" key={messageIndex}>
                                        <div className="comment-title">
                                          <div className="main">{message.creatorName}</div>
                                          <div className="sub">{moment(message.dateModified).format('DD MMM, YYYY - hh:mm')}</div>
                                        </div>
                                        <div className="comment-content">
                                          { message.type === "ANSWER_MESSAGE" &&
                                            <p>{message.text}</p>
                                          }
                                        </div>
                                      </div>
                                    )
                                  })
                                }
                              </div>
                            </div>
                          </div>
                        )
                      })
                    }
                  </div>
                </div>
              </div>
            }
            <div className="padding-15 margin-bottom-15">
              {
                attempt && answerIndex > 0 &&
                <RaisedButton
                  label="Back"
                  onClick={_this.navigateAnswer.bind(_this, -1)}
                />
              }
              {
                attempt && answerIndex < answers.length-1 &&
                <div className="float-right">
                  <RaisedButton
                    secondary={true}
                    label="Next"
                    onClick={_this.navigateAnswer.bind(_this, 1)}
                  />
                </div>
              }
            </div>
          </div>
        }
      </div>
    );
  },

  componentDidMount: function() {
    this.retrieveAttempt(() => {
      this.retrieveConceptsMap();
    })
  },
  componentDidUpdate: function(prevProps) {
    var _this = this;
    window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub, ReactDOM.findDOMNode(_this)]);
  },

});

module.exports = ViewSubmission;



/** WEBPACK FOOTER **
 ** ./src/components/Marking/ViewSubmission.js
 **/